// File: Pages/Reports/components/FAQ/DynamicFAQList.jsx

import React from 'react'
import PropTypes from 'prop-types'
import FAQCard from './FAQCard'
import styles from '../../index.module.css'

/**
 * Displays a list of FAQs based on the selected report type
 */
const DynamicFAQList = ({
  reportType,
  faqData,
  faqConfig
}) => {
  
  // Get the FAQ items for the selected report type
  const faqItems = faqData[reportType] || []
  
  // Configure titles from config or defaults
  const {
    title = 'Self-service Options',
    subtitle = 'Here are some resources that might help you resolve your issue:'
  } = faqConfig || {}
  
  
  if (faqItems.length === 0) {
    return null
  }
  
  
  return (
    <div>
      <h2 className={styles.sectionTitle}>{title}</h2>
      <p className={styles.sectionSubtitle}>{subtitle}</p>
      
      <div className={styles.faqGrid}>
        {faqItems.map((faq, index) => (
          <FAQCard
            key={index}
            title={faq.title}
            description={faq.description}
            url={faq.url}
          />
        ))}
      </div>
      
    </div>
  )
}

DynamicFAQList.propTypes = {
  reportType: PropTypes.string.isRequired,
  faqData: PropTypes.object.isRequired,
  faqConfig: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string
  })
}

export default DynamicFAQList